var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"absolute inset-x-0 top-full",attrs:{"data-testid":"cmsMenu"}},[_c('Storyblok',{attrs:{"renderSections":_vm.data.sections,"forceLazyLoad":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }